import { IJsonapiModel, Response } from 'datx-jsonapi';

type TwilioError = Error & { body: { status: number; message: string; code: number } };

const isTwilioError = (error: TwilioError | unknown): error is TwilioError => (error as TwilioError).body !== undefined;

export const getMessage = (error: TwilioError | Error | Response<IJsonapiModel>) => {
  if (isTwilioError(error)) {
    return error.body.message;
  }

  if (error instanceof Response) {
    if (Array.isArray(error.error)) {
      // show only the first error
      return error.error[0].detail;
    }

    return error.error.message;
  }

  return error.message;
};
